import gql from "graphql-tag";

export const GET_ALTADENA_DISCLAIMER = gql`
  query GetAltadenaDisclaimer {
    altadenaDisclaimer
  }
`;
